import React, { useState, useEffect } from 'react'
import axios from 'axios'
import FileDownload from 'js-file-download'
import {
  Div, Button, Loading, P,
} from 'konsys-ui'
import { DatePicker, Radio } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import { Bar } from 'react-chartjs-2'
import ReactTable from 'react-table'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { EXPENSE } from '../../constants/graphql/query'
import { theme } from '../../styles/_variables'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

const Wrapper = props => (
  <Div
    display='flex'
    width='100%'
    flexDirection='column'
    justifyContent='center'
    alignItems='center'
    padding={props.padding || '40px 0'}
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const Expense = () => {
  const [type, setType] = useState('ALL')
  const [date, setDate] = useState([moment().startOf('month'), moment().endOf('month')])
  const [isLoading, setIsLoading] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => { window.removeEventListener('resize', handleResize) }
  }, [])

  const download = () => {
    setIsLoading(true)
    const option = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      url: `${getURL().FILE_SERVER}/download/expense/report/?startDate=${date[0].format('YYYY-MM-DD')}&endDate=${date[1].format('YYYY-MM-DD')}`,
    }
    axios.all([axios(option)])
      .then(axios.spread((resp) => {
        FileDownload(resp.data, `รายงานค่าใช้จ่าย ${date[0].format('DD/MM/YYYY')}-${date[1].format('DD/MM/YYYY')}.xlsx`)
        setIsLoading(false)
      }))
  }

  const columnsTotal = [{
    Header: 'Fleet',
    accessor: 'fleetName',
    Cell: props => <P textAlign='center' bold={props.original.isSummary} display='block'>{props.value}</P>,
    sortable: false,
  }, {
    Header: 'ค่าใช้จ่าย',
    accessor: 'expense',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่ายาง',
    accessor: 'rubberCost',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าอะไหล่',
    accessor: 'partsCost',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าน้ำมัน',
    accessor: 'oilCost',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าแก๊ส',
    accessor: 'gasCost',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'เงินเดือน',
    accessor: 'salary',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'เบี้ยเลี้ยง',
    accessor: 'compensation',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    id: 'netTotal',
    Header: 'รวมทั้งหมด',
    accessor: d => d.expense + d.rubberCost + d.partsCost + d.oilCost + d.gasCost + d.salary + d.compensation,
    Cell: props => <P textAlign='right' bold={true} display='block' style={{ textDecoration: 'underline' }}>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
    width: 150,
  }]

  const columnsPadoongrich = [{
    Header: 'Fleet',
    accessor: 'fleetName',
    Cell: props => <P textAlign='center' bold={props.original.isSummary} display='block'>{props.value}</P>,
    sortable: false,
  }, {
    Header: 'ค่าทางด่วน',
    accessor: 'expensesHighway',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าเหยียบลาน',
    accessor: 'expensesEntrance',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าขึ้นค่าลง',
    accessor: 'expensesPickup',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าใช้จ่ายอื่นๆ',
    accessor: 'expensesOther',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าใช้จ่ายรวม',
    accessor: 'totalExpense',
    Cell: props => <P textAlign='right' bold={true} display='block' style={{ textDecoration: 'underline' }}>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
    width: 150,
  }, {
    Header: 'ค่ายกตู้หนัก',
    accessor: 'feePickupHeavy',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าผ่านท่าเรือ',
    accessor: 'feePierEntrance',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่ายกตู้เปล่า',
    accessor: 'feePickupNormal',
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าธรรมเนียมอื่นๆ',
    accessor: 'feeOther',
    width: 120,
    Cell: props => <P textAlign='right' bold={props.original.isSummary} display='block'>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
  }, {
    Header: 'ค่าธรรมเนียมรวม',
    accessor: 'totalFee',
    Cell: props => <P textAlign='right' bold={true} display='block' style={{ textDecoration: 'underline' }}>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
    width: 150,
  }, {
    id: 'netTotal',
    Header: 'รวมทั้งหมด',
    accessor: d => d.totalFee + d.totalExpense,
    Cell: props => <P textAlign='right' bold={true} display='block' style={{ textDecoration: 'underline' }}>{numeral(props.value).format('(0,0.00)')}</P>,
    sortable: false,
    width: 150,
  }]

  const padoongrichChart = {
    labels: ['ค่าทางด่วน', 'ค่าขึ้นค่าลง', 'ค่าผ่านท่าเรือ', 'ค่าใช้จ่ายอื่นๆ', 'ค่ายกตู้หนัก', 'ค่าเหยียบลาน', 'ค่ายกตู้เปล่า', 'ค่าธรรมเนียมอื่นๆ'],
    datasets: [
      {
        label: 'ค่าใช้จ่าย',
        backgroundColor: '#D95948',
        borderWidth: 0,
        hoverBackgroundColor: '#D95948bb',
      },
    ],
  }

  const totalChart = {
    labels: ['ค่าใช้จ่าย', 'ค่ายาง', 'ค่าอะไหล่', 'ค่าน้ำมัน', 'ค่าแก๊ส', 'เงินเดือน', 'เบี้ยเลี้ยง'],
    datasets: [
      {
        label: 'ค่าใช้จ่าย',
        backgroundColor: '#D95948',
        borderWidth: 0,
        hoverBackgroundColor: '#D95948bb',
      },
    ],
  }

  const selected = type === 'ALL' ? totalChart : padoongrichChart

  return (
    <Wrapper center={true}>
      <Div display='flex' alignItems='center' justifyContent='space-between' width='100%'>
        <DatePicker.RangePicker
          style={{ width: 'fit-content' }}
          onChange={e => !_.isEmpty(e) && setDate(e)}
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
        />
        <Button small icon='fas fa-print' text='พิมพ์ค่าใช้จ่าย' onClick={() => download()} loading={isLoading} disabled={isLoading} margin='0 0 0 16px' />
      </Div>
      <Div width='100%'>
        <Radio.Group buttonStyle='solid' defaultValue='ALL' size='large' style={{ display: 'block', width: 'fit-content', margin: '40px auto 0' }} onChange={e => setType(e.target.value)} value={type}>
          <Radio.Button value='ALL'>รวม</Radio.Button>
          <Radio.Button value='PADOONGRICH'>เบิกผดุงฤทธิ์</Radio.Button>
        </Radio.Group>
      </Div>
      <Query
        query={EXPENSE}
        variables={{ startDate: date[0].format(), endDate: date[1].format() }}
      >{({ data, loading, error }) => {
        if (loading) return <Loading style={{ margin: 40 }}/>
        if (error) return <P>Error</P>
        const { expenseInfo } = data.showExpense
        const { summaryTotal } = expenseInfo
        const { summaryPadoongrich } = expenseInfo
        return (
          <Div display='flex' alignItems='center' flexDirection='column' style={{ maxWidth: '100%' }}>
            <Div width='100%' height='350px' margin='40px 0 0 0'>
              <Bar
                style={{ margin: 'auto' }}
                data={{
                  ...selected,
                  datasets: [
                    {
                      ...selected.datasets[0],
                      data: type === 'ALL'
                        ? [expenseInfo.totalBarChart.expense, expenseInfo.totalBarChart.rubberCost, expenseInfo.totalBarChart.partsCost, expenseInfo.totalBarChart.oilCost, expenseInfo.totalBarChart.gasCost, expenseInfo.totalBarChart.salary, expenseInfo.totalBarChart.compensation]
                        : [expenseInfo.padoongrichBarChart.expensesHighway, expenseInfo.padoongrichBarChart.expensesEntrance, expenseInfo.padoongrichBarChart.expensesPickup, expenseInfo.padoongrichBarChart.expensesOther, expenseInfo.padoongrichBarChart.feePickupHeavy, expenseInfo.padoongrichBarChart.feePierEntrance, expenseInfo.padoongrichBarChart.feePickupNormal, expenseInfo.padoongrichBarChart.feeOther],
                    },
                  ],
                }}
                redraw={true}
                // height={350}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            </Div>
            <Div margin='40px 0 0 0' width='100%'>
              <ReactTable
                className='table'
                data={type === 'ALL' ? [...expenseInfo.totalTable, { ...summaryTotal, fleetName: 'รวมทั้งหมด', isSummary: true }] : [...expenseInfo.padoongrichTable, { ...summaryPadoongrich, fleetName: 'รวมทั้งหมด', isSummary: true }]} // *
                resizable={false}
                columns={type === 'ALL' ? columnsTotal : columnsPadoongrich} // *
                minRows={6}
                manual
                showPageSizeOptions={false}
                getTdProps={() => ({ disabled: true })} // *
                getTrProps={(state, rowInfo) => { // *
                  if (rowInfo) {
                    return {
                      style: {
                        padding: '8px 0',
                        backgroundColor: rowInfo.original.isSummary ? `${color.primaryColor}22` : color.offWhite,
                        borderLeft: `3px solid ${rowInfo.original.isSummary ? color.primaryColor : color.primaryColor}`,
                      },
                    }
                  } return {}
                }}
                previousText='ก่อนหน้า'
                nextText='ถัดไป'
                pageText='หน้า'
                ofText='จาก'
                noDataText='ไม่พบข้อมูล'
              />
            </Div>
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Expense
